import script from "./SuccessModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessModal.vue?vue&type=script&setup=true&lang=js"

import "./SuccessModal.vue?vue&type=style&index=0&id=5e0cce9c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e0cce9c"]])

export default __exports__